export type Interval = { start: number; end: number };

export const mergeIntervals = (intervals: Interval[]): Interval[] => {
  const merged: Interval[] = [];
  for (const interval of [...intervals].sort((a, b) => a.start - b.start)) {
    const last = merged[merged.length - 1];
    if (last && interval.start <= last.end + 1) {
      last.end = Math.max(last.end, interval.end);
    } else {
      merged.push({ ...interval });
    }
  }
  return merged;
};

export const totalDuration = (intervals: Interval[]): number =>
  intervals.reduce((total, interval) => total + (interval.end - interval.start), 0);

// Which half of the calendar month holds most of the covered time, for a month that is only partly covered.
export const getHalfFill = (covered: Interval[], month: Interval): "half-start" | "half-end" => {
  const midpoint = (month.start + month.end) / 2;
  const coveredBeforeMidpoint = covered.reduce(
    (total, interval) => total + Math.max(0, Math.min(interval.end, midpoint) - interval.start),
    0
  );
  return coveredBeforeMidpoint >= totalDuration(covered) - coveredBeforeMidpoint ? "half-start" : "half-end";
};
